import { useTranslation } from 'react-i18next';
import { Image, ImageBackground, Platform, StyleSheet, Text, View } from 'react-native';
import { useDispatch } from 'react-redux';

import { BGCollectBtn, BGHorDivider } from '../../../../assets';
import { collectBonusRequest } from '../../../../store/bonus/bonusActions';
import { TouchableOpacity } from '../../common/Touchable';

interface BGCollectButton {
	isSmall?: boolean;
	isCollecting?: boolean;
	isLogged?: boolean;
	onRequireLogin?: () => void;
}

function BGCollectButton({
	isSmall,
	isCollecting = false,
	isLogged = false,
	onRequireLogin,
}: BGCollectButton) {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const isWeb = Platform.OS === 'web';

	return (
		<View
			style={[
				styles.root,
				{
					width: isSmall ? '90%' : 150,
				},
			]}
		>
			<Image
				source={BGHorDivider}
				resizeMode='contain'
				style={[
					styles.dividerWide,
					{
						maxWidth: isSmall ? 180 : undefined,
						marginBottom: isSmall ? -6 : 0,
					},
				]}
			/>
			<View
				style={[
					styles.headingBlock,
					{
						marginVertical: isSmall && isWeb ? 6 : 1,
					},
				]}
			>
				<Text
					style={[
						styles.headingText,
						{
							fontSize: isSmall ? 14 : 16,
							fontFamily: Platform.OS === 'ios' ? 'Arial' : 'sans-serif',
						},
					]}
				>
					{t('T_SITE_BONUSES_HEADING')}
				</Text>
			</View>
			<Image
				source={BGHorDivider}
				resizeMode='contain'
				style={[
					styles.dividerMid,
					{
						maxWidth: isSmall ? 180 : undefined,
						marginTop: isSmall ? -6 : 0,
					},
				]}
			/>
			<TouchableOpacity
				onPress={() => {
					if (!isLogged) {
						onRequireLogin?.();
						return;
					}
					if (isCollecting) return;
					dispatch(collectBonusRequest());
				}}
				activeOpacity={0.7}
				style={[
					styles.collectTouchable,
					{
						width: isSmall ? '80%' : '90%',
						marginTop: isSmall && isWeb ? 6 : 0,
					},
				]}
			>
				<View style={styles.collectInner}>
					<ImageBackground
						source={BGCollectBtn}
						style={[
							styles.collectBg,
							{
								width: isSmall ? 100 : 100,
								height: isSmall ? 26 : undefined,
								aspectRatio: isSmall ? undefined : 3.4,
								marginTop: isSmall ? 0 : 6,
								marginBottom: isSmall ? 0 : 6,
							},
						]}
					>
						<Text
							style={[
								styles.collectLabel,
								{
									fontSize: isSmall ? 12 : 14,
									fontFamily: Platform.OS === 'ios' ? 'Arial' : 'sans-serif',
								},
							]}
						>
							{t('T_RB_Collect')}
						</Text>
					</ImageBackground>
				</View>
			</TouchableOpacity>
			<Image
				source={BGHorDivider}
				resizeMode='contain'
				style={[
					styles.dividerWide,
					{
						maxWidth: isSmall ? 180 : undefined,
						marginTop: isSmall ? -4 : 0,
					},
				]}
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	root: {
		alignItems: 'center',
		justifyContent: 'center',
		marginHorizontal: 'auto',
	},
	dividerWide: {
		width: '100%',
		aspectRatio: 27.5,
	},
	dividerMid: {
		width: '100%',
		aspectRatio: 22,
	},
	headingBlock: {
		alignItems: 'center',
		justifyContent: 'center',
		marginVertical: 1,
	},
	headingText: {
		color: '#fff',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		textShadowColor: 'rgba(0, 0, 0, 0.98)',
		textShadowOffset: { width: 0, height: 3 },
		textShadowRadius: 4,
		letterSpacing: 0.6,
		textAlign: 'center',
	},
	collectTouchable: {
		justifyContent: 'center',
		alignItems: 'center',
	},
	collectInner: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	collectBg: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	collectLabel: {
		color: '#fff',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		textShadowColor: 'rgba(0, 0, 0, 0.98)',
		textShadowOffset: { width: 0, height: 3 },
		textShadowRadius: 4,
		letterSpacing: 0.6,
	},
});

export default BGCollectButton;
